/**
 * This file is used to configure the app
 *
 * If you have the "Cannot find name 'defineAppConfig'.ts(2304)" error
 * update the root tsconfig.json file to include the following:
 *
 *  "extends": "./.app/.nuxt/tsconfig.json"
 *
 */

export default defineAppConfig({
  tairo: {
    collapse: {
      circularMenu: {
        enabled: false,
        tools: [],
      },
      navigation: {
        enabled: true,
        header: {
          component: 'SidebarHeader',
        },
        footer: {
          component: 'SidebarFooter',
        },
        items: [
          {
            icon: { name: 'material-symbols:home' },
            name: 'Home',
            to: '/portal',
          },
          {
            icon: { name: 'fluent:drink-beer-24-regular' },
            name: 'Drinken',
            to: '/portal/drinks',
          },
          {
            icon: { name: 'clarity:employee-line' },
            name: 'Werknemers',
            to: '/portal/employees',
          },
          {
            icon: { name: 'material-symbols:package-2-outline' },
            name: 'Pakketen',
            to: '/portal/packages',
          },
          {
            icon: { name: 'clarity:trailer-solid' },
            name: 'Aanhangwagens',
            to: '/portal/trailers',
          },
          {
            icon: { name: 'material-symbols:pedal-bike-outline' },
            name: 'Feestfietsen',
            to: '/portal/partybikes',
          },
          {
            icon: { name: 'material-symbols:auto-towing' },
            name: 'Takelwagens',
            to: '/portal/towtrucks',
          },
          {
            icon: { name: 'clarity:wrench-line' },
            name: 'Schade types',
            to: '/portal/damage',
          },
          {
            icon: { name: 'material-symbols:book-2-outline' },
            name: 'Boekingen',
            to: '/portal/bookings',
          },
          {
            icon: { name: 'material-symbols:map-outline' },
            name: 'Verzend kosten',
            to: '/portal/transport',
          },
          {
            icon: { name: 'uis:calender' },
            name: 'Planner',
            to: '/portal/planner',
          },
          {
            children: [
              {
                icon: { name: 'mdi:lightning-bolt' },
                name: 'Schade',
                to: '/portal/damages',
              },
            ],
            icon: { name: 'material-symbols:notification-important-rounded' },
            name: 'Notificaties',
          },
          {
            icon: { name: 'mdi:office-building' },
            name: 'Boekingsbedrijven',
            to: '/portal/agencies',
          },
          {
            icon: { name: 'solar:users-group-two-rounded-linear' },
            name: 'Gebruikers',
            to: '/portal/users',
          },
          {
            icon: { name: 'mingcute:coupon-fill' },
            name: 'Coupons',
            to: '/portal/coupons',
          },
        ],
      },
      toolbar: {
        enabled: true,
        showNavBurger: true,
        showTitle: true,
        tools: [
          {
            component: 'ToolbarLogo',
            props: {
              class: 'h-10 w-10',
            },
          },
        ],
      },
    },
    panels: [
      {
        component: 'PanelCalendarEntry',
        name: 'calendar-entry',
        position: 'right',
      },
      {
        component: 'PanelBookingForm',
        name: 'booking-form',
        position: 'right',
      },
      {
        component: 'PanelBookingProposal',
        name: 'booking-proposal',
        position: 'right',
      },
      {
        component: 'PanelAbsence',
        name: 'absence',
        position: 'right',
      },
      {
        component: 'PanelEditPackage',
        name: 'edit-package',
        position: 'right',
      },
      {
        component: 'PanelPlanner',
        name: 'planner',
        position: 'right',
      },
    ],
    title: 'Feestfiets',
  },
})
